import React, { useRef, useState, useEffect } from "react";
import './Style.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
} from "react-router-dom";
import $ from "jquery";

import Navbar from './common/Navbar.js';
import Footer from './common/Footer.js';
import Mainbanner from './Pages/Mainbanner.js';
import AllCategory from './Pages/AllCategory.js';

// ==========================CategoryPages===========================

import Minitabletop from './CategoryPages/Minitabletop.js';
import Benchplatformscale from './CategoryPages/Benchplatformscale.js';
import Cashcountingmachine from './CategoryPages/Cashcountingmachine.js';
import Cranescale from './CategoryPages/Cranescale.js';
import Healthscale from './CategoryPages/Healthscale.js';
import Heavydutyplatformscale from './CategoryPages/Heavydutyplatformscale.js';
import JewelleryScale from './CategoryPages/JewelleryScale.js';
import Platformscale from './CategoryPages/Platformscale.js';
import Portablescale from './CategoryPages/Portablescale.js';
import Pricecomputingscale from './CategoryPages/Pricecomputingscale.js';
import Tabletopscale from './CategoryPages/Tabletopscale.js';

// ===============================CategoryDetails=====================

// ===============================Benchplatformscale========================

import BTB_16 from './CategoryDetails/BenchplatformScale/BTB_16.js';

// ===============================Healthscale========================

import Adultweighingscale from './CategoryDetails/Healthscale/Adultweighingscale.js';
import Personweighingscale from './CategoryDetails/Healthscale/Personweighingscale.js';
import Babyweighingscale from './CategoryDetails/Healthscale/Babyweighingscale.js';

// ===============================Heavydutyplatformscale======================== 

import Fourloadcellplatform from './CategoryDetails/HeavydutyplatformScale/Fourloadcellplatform.js';
import HeavyMSplatform from './CategoryDetails/HeavydutyplatformScale/HeavyMSplatform.js';

// ===============================JewelleryScale======================== 

import Jewelleryscale_1 from './CategoryDetails/JewelleryScale/Jewelleryscale_1.js';

// ===============================Minitabletop========================
import BTB_5 from './CategoryDetails/Minitabletop/BTB_5.js';
import BTB_6 from './CategoryDetails/Minitabletop/BTB_6.js';
import Economicchottuscale from './CategoryDetails/Minitabletop/Economicchottuscale.js';
import MTB_6_green from './CategoryDetails/Minitabletop/MTB_6_green.js';
import MTB_6 from './CategoryDetails/Minitabletop/MTB_6.js';
import Micro from './CategoryDetails/Minitabletop/Micro.js';
import Miltonchottuscale from './CategoryDetails/Minitabletop/Miltonchottuscale.js';
import Minipole from './CategoryDetails/Minitabletop/Minipole.js';

// ===============================PlatformScale======================== 

import MSplatform from './CategoryDetails/PlatformScale/MSplatform.js';
import SSplatform from './CategoryDetails/PlatformScale/SSplatform.js';

// ===============================Portablescale======================== 

// import BPF_35 from './CategoryDetails/Portablescale/BPF_35.js';
// import MPF_35 from './CategoryDetails/Portablescale/MPF_35.js';

// ===============================TabletopScale======================== 

import BTB_10 from './CategoryDetails/TabletopScale/BTB_10.js';
import BTB_10_pole from './CategoryDetails/TabletopScale/BTB_10_pole.js';
import BTB_14 from './CategoryDetails/TabletopScale/BTB_14.js';
import BTB_15 from './CategoryDetails/TabletopScale/BTB_15.js';
import MTB_14 from './CategoryDetails/TabletopScale/MTB_14.js';
import logo from './Assets/Images/logo-short.png';


function App() {


  return (
    <div>

      <Navbar />
      <Router >

        <Routes>

          <Route exact path="/" element={<Mainbanner />} />
          <Route exact path="/AllCategory" element={<AllCategory />} />
          {/* <Route exact path="/Footer" element={<Footer />} /> */}



          {/* ==========================CategoryPages=========================== */}

          <Route exact path="/Minitabletop" element={<Minitabletop />} />
          {/* <Route exact path="/Benchplatformscale" element={<Benchplatformscale />} /> */}
          <Route exact path="/Cashcountingmachine" element={<Cashcountingmachine />} />
          <Route exact path="/Cranescale" element={<Cranescale />} />
          <Route exact path="/Healthscale" element={<Healthscale />} />
          <Route exact path="/Heavydutyplatformscale" element={<Heavydutyplatformscale />} />
          <Route exact path="/JewelleryScale" element={<JewelleryScale />} />
          <Route exact path="/Platformscale" element={<Platformscale />} />
          <Route exact path="/Portablescale" element={<Portablescale />} />
          <Route exact path="/Pricecomputingscale" element={<Pricecomputingscale />} />
          <Route exact path="/Tabletopscale" element={<Tabletopscale />} />

          {/* ===============================CategoryDetails===================== */}

          {/* ===============================Benchplatformscale======================== */}

          <Route exact path="/BTB_16" element={<BTB_16 />} />

          {/* ===============================Healthscale======================== */}

          <Route exact path="/Adultweighingscale" element={<Adultweighingscale />} />
          <Route exact path="/Personweighingscale" element={<Personweighingscale />} />
          <Route exact path="/Babyweighingscale" element={<Babyweighingscale />} />

          {/* ===============================Heavydutyplatformscale======================== */}

          <Route exact path="/HeavyMSplatform" element={<HeavyMSplatform />} />
          <Route exact path="/Fourloadcellplatform" element={<Fourloadcellplatform />} />

          {/* ===============================JewelleryScale========================  */}

          <Route exact path="/Jewelleryscale_1" element={<Jewelleryscale_1 />} />

          {/* ===============================Minitabletop======================== */}
          <Route exact path="/BTB_5" element={<BTB_5 />} />
          <Route exact path="/BTB_6" element={<BTB_6 />} />
          <Route exact path="/Economicchottuscale" element={<Economicchottuscale />} />
          <Route exact path="/MTB_6_green" element={<MTB_6_green />} />
          <Route exact path="/MTB_6" element={<MTB_6 />} />
          <Route exact path="/Micro" element={<Micro />} />
          <Route exact path="/Miltonchottuscale" element={<Miltonchottuscale />} />
          <Route exact path="/Minipole" element={<Minipole />} />

          {/* ===============================PlatformScale========================  */}

          <Route exact path="/MSplatform" element={<MSplatform />} />
          <Route exact path="/SSplatform" element={<SSplatform />} />

          {/* ===============================Portablescale========================  */}

          {/* <Route exact path="/BPF_35" element={<BPF_35 />} />
          <Route exact path="/MPF_35" element={<MPF_35 />} /> */}

          {/* ===============================TabletopScale========================  */}

          <Route exact path="/BTB_10" element={<BTB_10 />} />
          <Route exact path="/BTB_10_pole" element={<BTB_10_pole />} />
          <Route exact path="/BTB_14" element={<BTB_14 />} />
          <Route exact path="/BTB_15" element={<BTB_15 />} />
          <Route exact path="/MTB_14" element={<MTB_14 />} />

        </Routes>

      </Router >
      <Footer />
    </div>

  );
}

export default App;
